import styled, { css } from 'styled-components';
import convertHexToRgba from '~/helpers/convertHexToRgba';

export const AddOnStyled = styled.div.attrs({
  className: 'addon-screen',
})`
  ${({ theme, isScrollable, useBoldHeading, useCenteredHeading, hasDescription }) => {
    const { colors, media } = theme;
    return css`
      background-color: ${colors.primary.white};
      box-shadow: 0 20px 40px 0 ${convertHexToRgba(colors.primary.black, 0.25)};
      max-width: 1380px;
      width: 60vw;
      max-height: 100%;
      padding: 4% 8%;
      border-radius: 32px;
      position: relative;
      overflow-y: ${isScrollable ? 'scroll' : 'visible'};

      ${media.tablet.only} {
        width: 96vw;
      }

      ${media.mobile.down} {
        width: 90vw;
        padding: 10% 8%;
      }

      .icon--fill-close-thin {
        fill: ${colors.secondary.gray};
        height: 16px;
        position: absolute;
        right: 1.5rem;
        top: 1.5rem;
        cursor: pointer;
      }

      .addon-screen {
        &__header {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          h3 {
            color: ${theme.colors.primary.darkBlue};
            font-weight: 700;
            font-size: 42px;
            margin-top: 32px;

            ${media.tablet.down} {
              font-size: 18px;
            }
          }
        }

        &__container {
          display: flex;
          flex-direction: column;
          line-height: 20px;
          color: ${theme.colors.primary.darkBlue};
        }

        &__description {
          padding: 32px 0 20px;
        }

        &__subheading {
          margin-bottom: 16px;
          font-weight: 700;
        }

        &__subcopy {
          margin-bottom: 16px;
        }

        &__content {
          display: flex;
          align-items: flex-start;

          img {
            ${media.tablet.only} {
              width: 20%;
            }

            ${media.mobile.down} {
              display: none;
            }
          }

          .legal {
            font-size: 10px;
            line-height: 14px;
            font-weight: 400;

            a {
              text-decoration: underline;
            }
          }
        }

        &__checklistHeading {
          margin-top: ${hasDescription ? '0px' : '16px'};
          margin-bottom: 16px;
          font-weight: ${useBoldHeading ? '700' : '400'};
          text-align: ${useCenteredHeading ? 'center' : 'normal'};
        }

        &__checklist {
          display: flex;
          flex-direction: row;
          align-items: start;
          padding-bottom: 20px;

          ${media.tablet.down} {
            padding-bottom: 8px;
          }
        }

        &__checklist--indented {
          padding-left: 5px;
        }

        &__checklistCheck {
          color: ${colors.primary.red};
          padding-right: 4px;

          svg {
            height: 12px;
          }
        }

        &__checklistItemHeading {
          font-weight: 700;
        }

        &__channels {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 24px;
          padding: 24px 20px;
          border: solid 1px ${theme.colors.primary.darkBlue};
          border-radius: 24px;
        }

        &__channelsHeading {
          margin-bottom: 16px;
          padding-top: 0;
          font-size: 16px;
          font-weight: 500;
          text-align: center;

          ${media.tablet.up} {
            font-size: 20px;
          }

          ${media.desktop.up} {
            font-size: 24px;
          }
        }

        &__channelsLink {
          margin-top: 20px;
          font-size: 12px;
          text-decoration: underline;
        }

        &__setupinfo {
          padding: 30px 14px;
          border-radius: 24px;
          background-color: ${colors.secondary.gray};
          color: ${theme.colors.primary.darkBlue};
          max-height: 100px;
          overflow: hidden;

          ${media.tablet.up} {
            padding: 36px 40px;
          }

          ${media.desktop.up} {
            padding-right: 64px;
            padding-left: 64px;
          }
        }

        &__setupinfo[open] {
          max-height: 1000px;
          background-color: ${theme.colors.primary.darkBlue};
          color: ${colors.primary.white};
          transition: max-height 0.7s linear;
        }

        &__setupinfo[open] .addon-screen__setupinfoHeadingIcon {
          transform: rotate(180deg);
        }

        &__setupinfo[open] .addon-screen__setupinfoListItem::before {
          color: ${theme.colors.primary.darkBlue};
        }

        &__setupinfoHeading {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 0;
          margin-bottom: 0;
          font-size: 18px;

          ${media.tablet.up} {
            font-size: 20px;
          }
        }

        &__setupinfoHeading:hover {
          cursor: pointer;
        }

        &__setupinfoHeadingIcon {
          height: 20px;
          width: 20px;
          transition: transform 0.3s linear;
        }

        &__setupinfoList {
          margin-top: 16px;
          padding-left: 0;
          counter-reset: customCounter;
          transition: max-height 0.7s linear;
        }

        &__setupinfoListItem {
          display: flex;
          align-items: flex-start;
          margin-bottom: 0;
          font-size: 14px;
          counter-increment: customCounter;
        }

        &__setupinfoListItem:not(:last-child) {
          margin-bottom: 16px;
        }

        &__setupinfoListItem::marker {
          content: '';
        }

        &__setupinfoListItem::before {
          content: counter(customCounter);
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: ${colors.primary.white};
          min-width: 20px;
          min-height: 20px;
          margin-right: 16px;
          padding: 2px 3px;
          border-radius: 50%;
        }
      }

      ${media.desktop.only} {
        .addin-screen {
          &__header {
            .value {
              padding-top: 10px;
            }

            h3 {
              flex: 0 0 60%;
              font-size: 42px;
            }
          }
        }
      }
    `;
  }}
`;
